import { useCallback } from 'react';
import { useAlgoliaAnalytics } from './useAlgoliaAnalytics';
import { mapAttributesToStringFilters } from '~/shared/hooks/useAlgoliaAnalytics/utils';
import { Refinement } from 'react-instantsearch-core';
import { useSessionStorage } from 'react-use';
import { useCookieConsent } from '~/shared/hooks/useCookieConsent';

export const useAlgoliaTracking = () => {
    const { trackViewedFilters, trackConvertedFilters } = useAlgoliaAnalytics();
    const [algoliaViewedAttributes, setAlgoliaViewedAttributes] = useSessionStorage<
        string[] | null
    >('algoliaViewedAttributes', null);
    const { statistic } = useCookieConsent();

    const trackViewedAttributes = useCallback(
        (attributes: Refinement[]) => {
            const mappedAttributes = mapAttributesToStringFilters(attributes);

            if (mappedAttributes.length) {
                trackViewedFilters(mappedAttributes);
            }

            if (mappedAttributes.length && statistic) {
                setAlgoliaViewedAttributes(mappedAttributes);
            }
        },
        [setAlgoliaViewedAttributes, statistic, trackViewedFilters]
    );

    const trackAndResetConvertedFilters = () => {
        if (algoliaViewedAttributes) {
            const attr = algoliaViewedAttributes;
            trackConvertedFilters(attr);
            setAlgoliaViewedAttributes(null);
        }
    };

    return { trackViewedAttributes, trackAndResetConvertedFilters };
};
